module.exports = __webpack_public_path__ + "43c1519f5e0f298ebac02b35e25ff008.svg";